<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhoneHorisontal_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M3.547 12.862c-.252-.9-.024-1.934.606-2.768 1.213-1.605 3.886-2.55 7.969-2.55 4.99 0 7.087 1.387 7.968 2.55.631.833.858 1.867.606 2.768a1.356 1.356 0 0 1-1.644.955l-2.926-.731a1.363 1.363 0 0 1-1.034-1.325l-.016-1.043a12.45 12.45 0 0 0-2.953-.329c-1 0-1.957.092-2.924.28l-.045 1.099a1.358 1.358 0 0 1-1.034 1.319l-2.926.731a1.362 1.362 0 0 1-1.647-.956Z"
    />
</svg>
